import { useEffect, useState } from 'react';

import { AppService } from '../../../services/api';

export const useAppLocation = (appId: string) => {
  const [appLocation, setAppLocation] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!appId) return;

    const getAppLocation = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const { location } = await AppService.getAppLocation({ id: appId });
        setAppLocation(location || null);
      } catch (err) {
        const error = err instanceof Error ? err : new Error('Failed to get app location');
        setError(error);
        setAppLocation(null);
        console.error('Error fetching app location:', error);
      } finally {
        setIsLoading(false);
      }
    };

    void getAppLocation();
  }, [appId]);

  return { appLocation, isLoading, error };
};
